import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeCard = ({ user }) => {
  const currentHour = new Date()?.getHours();
  const greeting = currentHour < 12 ? 'Good morning' : currentHour < 18 ? 'Good afternoon' : 'Good evening';

  return (
    <div className="bg-gradient-to-r from-primary to-primary/80 rounded-lg p-6 text-white">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold mb-2">
            {greeting}, {user?.name}!
          </h1>
          <p className="text-white/90 mb-4">
            Welcome back to your property dashboard. Here's what's happening with your searches.
          </p>
          <div className="flex items-center space-x-4 text-sm">
            <div className="flex items-center space-x-1">
              <Icon name="Heart" size={16} />
              <span>{user?.savedProperties} Saved</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="Search" size={16} />
              <span>{user?.activeSearches} Active Searches</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="Calendar" size={16} />
              <span>{user?.scheduledTours} Tours Scheduled</span>
            </div>
          </div>
        </div>
        <div className="hidden md:block">
          <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center">
            <Icon name="Home" size={32} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeCard;